<template lang="html">
  <div class="btn-group-wrapper">
    <a 
      :href="baseUrlStorage+file" 
      v-if="file" 
      class="btn-group"
      target="_blank"
      :download="true"
    >
      <ButtonIcon nameIcon="download"/>
    </a>
    <div v-if="socialMedia"  class="btn-group">
      <ButtonIcon nameIcon="facebook" />
      <ButtonIcon nameIcon="linkedin" />
      <ButtonIcon nameIcon="twitter" />
    </div>
  </div>
</template>
<script>
import ButtonIcon from "./ButtonIcon.vue";

export default {
  components: {
    ButtonIcon,
  },
  inject: ["baseUrlStorage"],
  props: {
    file: String,
    socialMedia: Boolean,
  },
};
</script>
<style lang="css" scoped>
.btn-group-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 8px;
}
.btn-group-wrapper .btn-group {
  display: flex;
  flex-direction: column;
  row-gap: 18px;
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  padding: 22px;
}

@media (max-width: 768px) {
  .btn-group-wrapper {
    flex-direction: row;
    column-gap: 10px;
  }
  .btn-group-wrapper .btn-group {
    flex-direction: row;
    column-gap: 20px;
  }
}
</style>
